<template>
	<div id="LotListComponent">
        <nav class="navbar navbar-light bg-light">
			<div class="form-inline">
				<input class="form-control form-control-sm mr-sm-1" type="date" v-model="dateFromLots" @change="getAllLotsLocal(1)">
				<input class="form-control form-control-sm mr-sm-1" type="date" v-model="dateToLots" @change="getAllLotsLocal(1)">
				<input class="form-control form-control-sm mr-sm-1" type="search" placeholder="Buscar" aria-label="Buscar" ref="searchLots"
					v-model="searchLots"
					v-on:keyup.enter="getAllLotsLocal(1)"
					@focus="$event.target.select()">
				<button class="btn btn-sm btn-outline-info my-2 my-sm-1" type="submit" @click="getAllLotsLocal(1)">Buscar</button>
				<div class="float-right d-none d-sm-inline separator"></div>
			</div>
			<div class="form-inline">
				<span class="mr-sm-1">Mostrar</span>
				<select class="form-control form-control-sm mr-sm-1 float-sm-right margin-right5 " id="qrows" v-model="qRowsLot" @change="changeQRowsLot">
					<option>5</option>
					<option>10</option>
					<option>25</option>
					<option>50</option>
					<option>100</option>
					<option>200</option>
					<option>1000</option>
			    </select>
			</div>
		</nav>
		<table class="table table-sm table-12">
			<thead>
				<tr>
					<th class="text-center">ID</th>
					<th class="text-center">Usuario</th>
					<th class="text-center">Campo</th>
					<th class="text-center">Fecha</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(item, index) in listLots" :key="index">
					<td class="text-center">{{item.id}}</td>
					<td>{{item.user.name}}</td>
					<td>{{item.entity.name}}</td>
					<td class="text-center">{{item.created_at}}</td>
					<td>
						<i class="pointer far fa-eye text-info" title="Ver detalle" @click="viewDetailLocal(item)"></i>
					</td>
				</tr>
			</tbody>
		</table>
		<pagination :pagination="paginationLots" @getAllList="getAllLotsLocal"></pagination>
	</div>
</template>

<script>
import mixin from '@/mixins'
import errors from '@/mixins/errors.js'
import axiosAction from '@/mixins/axiosAction.js'
import lots from '@/mixins/lots'

import Pagination from '@/components/Pagination.vue'
export default {
	name: 'LotListComponent',
	mixins: [axiosAction, errors, mixin, lots],
	data () {
		return {
		}
	},
	components: {
		'pagination': Pagination,
	},
	methods: {
		initModuleLocal() {
			this.setLotInit()
		},
		changeQRowsLotLocal() {
			this.getAllLotsLocal(1)
		},
		getAllLotsLocal(page = 1) {
			this.getAllLots(page)
		},
		getAllLotsResultLocal(response) {},
		resultAxiosLocal(responseLocal, response) {
			this.$emit('hideLockScreen')
			switch(responseLocal) {
				case 'getAllLotsResult': this.getAllLotsResult(response); break;
		        default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
			}
		},
		setLotInitLocal() {

		},
		viewDetailLocal(lot) {
			this.$emit('viewDetail', lot)
		}
	},
	mounted () {
		this.initModule()
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
